export default function CapitalAboutDialogTemplate(data) {
    //language=HTML
    return `
        <div id="aboutDialog">
            <div class="row topBordered w-100">
            <span class="col-md-3">
                ${data.translateId("appVersionNumber")}
            </span>
                <span class="col-md-9">
                ${data.applicationVersion}
            </span>
            </div>
            <div class="row topBordered w-100">
            <span class="col-md-3">
                ${data.translateId("dbBuildDate")}
            </span>
                <span class="col-md-9">
                ${data.dbBuildDate}
            </span>
            </div>
            <div class="row topBordered w-100">
            <span class="col-md-3">
                ${data.translateId("latestRelease")}
            </span>
                <span class="col-md-9">
                ${data.latestRelease}
            </span>
            </div>
            <div class="row topBordered w-100">
            <span class="col-md-3">
                ${data.translateId("customerSupportEndDate")}
            </span>
                <span class="col-md-9">
                ${data.customerSupportEndDate}
            </span>
            </div>
            <div class="row topBordered w-100">
            <span class="col-md-3">
                ${data.translateId("licenceDetails")}
            </span>
                <span class="col-md-9">
                ${data.licenceDetails}
            </span>
            </div>
            <div class="row topBordered w-100">
            <span class="col-md-3">
                ${data.translateId("contactInfo")}
            </span>
                <span class="col-md-9">
            </span>
            </div>
            <div class="row topBordered w-100">
            <span class="col-md-3">
                ${data.translateId("egypt")}
            </span>
                <div class="col-md-9">
                    <address>۹۰ شارع السيد المرغني، کلیة البنات، مصر الجديدة، القاهرة</address>
                    <address>90 El-Sayed El-Merghany, Kolleyet El Banat, Heliopolis, Cairo</address>
                    <address>
                        <a href="tel:0020226909962 ">0020226909962</a>
                        <a href="tel:0020226909961 ">0020226909961</a>
                        <a href="tel:00201000671821 ">00201000671821</a>
                    </address>
                    <address>
                        <a href="emailto:info@ecpa-eg.com">info@ecpa-eg.com</a>
                    </address>
                    <address>
                        <a href="https://www.facebook.com/EgyptianCPA" target="_blank">
                            <img src="images/fb.png" class="fb-logo" style="height: 32px;width: 32px"/>
                        </a>
                        <a href="https://twitter.com/EgyptianCPA" target="_blank">
                            <img src="images/tw.jpg" class="tw-logo" style="height: 32px;width: 32px"/>
                        </a>
                        <a href="https://www.linkedin.com/company/egyptian-cpa/" target="_blank">
                            <img src="images/ln.png" class="tw-logo" style="height: 32px;width: 32px"/>
                        </a>
                        <a href="https://www.youtube.com/user/EgyptianCPAs" target="_blank">
                            <img src="images/yt.png" class="tw-logo" style="height: 32px;width: 32px"/>
                        </a>
                    </address>
                </div>
            </div>
            <div class="row topBordered w-100">
            <span class="col-md-3">
                ${data.translateId("uae")}
            </span>
                <div class="col-md-9">
                    <address>٤ شارع العرشان الحصن الخالدية بناية بنك ابو ظبي الاول مكتب رقم 1104 – الإمارات العربیة المتحدة</address>
                    <address>4 Al Irshan st Al Hisn Khaldia Fab bank Building office no 1104 –
                        Abu Dhabi – UAE
                    </address>
                    <address>
                        <a href="https://goo.gl/maps/eMyfpYzrF1kZqkky8">9 th Floor, Damac XL Tower,Business Bay, Dubai – UAE</a>
                    </address>
                    <address>
                        <a href="tel:00971501242584">00971501242584</a>
                    </address>
                    <address>
                        <a href="tel:00971502242290">00971502242290</a>
                    </address>
                    <address>
                        <a href="emailto:info@ecpa-eg.com">info@ecpa-eg.com</a>
                    </address>
                </div>
            </div>
            <div class="row topBordered w-100">
                <div class="col-md-12">
                    <div class="textAlignCenter">
                        <a href='${data.translateId("appUrl")}' target="_blank">${data.translateId("appUrl")}</a>
                    </div>
                </div>
            </div>
        </div>`;
}